export var getTheme = function getTheme(theme) {
  return require("./".concat(theme, ".css"));
};
export var getRoundButtonTheme = function getRoundButtonTheme(theme) {
  return require("./".concat(theme, ".css"));
};